import React from 'react';
import { ListSelectionProvider } from '@clds/compound-components';
import { ChildDataRegistryProvider } from './childData';
export const MenuProvider = ({ children, registry, select, focusedId, selectedId, }) => (React.createElement(ChildDataRegistryProvider, { value: registry },
    React.createElement(ListSelectionProvider, { onClick: select, focusedId: focusedId, selectedId: selectedId }, children)));
//# sourceMappingURL=MenuProvider.js.map